// extracted by mini-css-extract-plugin
module.exports = {"termsWrap":"Terms_termsWrap__tp46g","des":"Terms_des__uHujX","dark":"Terms_dark__I79uW","subUl":"Terms_subUl__ZQwY_"};